<script>
import Notification from '../../reUse/Notification.vue';
import DropDown from '../../reUse/DropDown.vue';
export default {
  components: {
    Notification,
    DropDown,
  },
  emits: ['backToAdmin'],
  data() {
    return {
      izbranUserId: '',
      izbranoLetalisce: 'LJAJ',
      izbranoLetalo: '',
      izbranoLetaloId: '',
      izbraniULetala: [],
      uporabniki: [],
      letala: [],
      dLetalo: false,
      upravniki: [],
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  mounted() {
    this.GetUporabniki();
    this.GetLetala();
    this.GetUpravljalci();
  },
  computed: {},
  methods: {
    GetUporabniki() {
      axios.get('./api/uporabniki/izpis/', {withCredentials: true}).then((response) => {
        this.uporabniki = response.data.uporabniki;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    GetLetala() {
      axios.get('./api/sifranti/letala/izpis/', {withCredentials: true}).then((response) => {
        this.letala = response.data.letala;
        // this.Upravljalci();
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    GetUpravljalci() {
      axios.get('./api/sifranti/letala/upravitelji/izpis/', {withCredentials: true}).then((response) => {
        this.upravniki = response.data.upravitelji;
        // this.Upravljalci();
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    Letala() {
      this.izbraniULetala = new Array;
      for (var i = 0; i < this.upravniki.length; i++) {
        if (this.upravniki[i].id_letala === this.izbranoLetaloId) {
          this.izbraniULetala.push(this.upravniki[i]);
        }
      }
    },
    selectLetalo(id) {
      let letalo = this.letala.find(l => l.id === id);
      if (letalo) {
        this.izbranoLetaloId = id;
        this.izbranoLetalo = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
        this.Letala();
      }
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OdstraniUpravitelja(id) {
      var upravnik = [];
      var pUpravnik = [];
      for (var i = 0; i < this.izbraniULetala.length; i++) {
        if (this.izbraniULetala[i].id_pilota !== id) {
          upravnik.push(this.izbraniULetala[i]);
        }
      }
      this.izbraniULetala = upravnik;
      var podatki = new URLSearchParams();
      podatki.append('id_letala', this.izbranoLetaloId);
      podatki.append('id_upravitelja', id);
      axios.post('./api/sifranti/letala/upravitelji/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.GetUpravljalci();
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    Povezi() {
      var podatki = new URLSearchParams();
      podatki.append('id_letala', this.izbranoLetaloId);
      podatki.append('id_upravitelja', this.izbranUserId);
      axios.post('./api/sifranti/letala/upravitelji/vnos/', podatki, {withCredentials: true}).then((response) => {
        this.GetUpravljalci();
        setTimeout(() => {
          this.Letala();
        }, 200);
        this.izbranUserId = '';
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
  }
}
</script>
<template>
  <!-- <button class="p-2 btn-back" @click.prevent="$emit('backToAdmin')"><i class="fas fa-arrow-up fa-2x"></i></button> -->
  <h5 class="d-flex justify-content-center text-white">Upravljanje upravljalcev letal</h5>
  <div class="container p-2">
    <div class="col-12">
      <!-- Letalo -->
      <div class="container p-2">
        <label class="label-dropdown" for="regLetala">Registracija letala <button v-if="izbranoLetalo !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="izbranoLetalo = ''">Briši izbiro</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenLetalo">{{izbranoLetalo}}</button>
        <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
        </transition>
      </div>
      <!-- Uporabniki -->
      <div class="container p-2">
        <div class="label-date col-6 p-2" for="izbranUserId">Uporabnik</div>
        <select class="input border-0 rounded-4 p-2 fs-5" v-model='izbranUserId'>
          <option disabled value=''>Izberi uporabnika</option>
          <option v-for='uporabnik in uporabniki' :disabled="this.izbraniULetala.some(upravnik => upravnik.id_pilota == uporabnik.id)" :value='uporabnik.id'>{{uporabnik.ime}} {{uporabnik.priimek}}</option>
        </select>
      </div>
    </div>
    <div class='col-12'>
      <div class="container p-2">
        <button @click.prevent="Povezi()" class="btn btn-primary rounded-pill btn-add col-12">Dodaj</button>
      </div>
    </div>
    <div class="hr-with-text p-2">UPRAVLJALCI LETALA {{izbranoLetalo}}</div>
    <!-- IZPIS UPRAVLJALCI -->
    <div class='col-12'>
      <div class="container row p-2" v-for='upravnik in izbraniULetala'>
        <div class="col-10 text-podatki text-manjsi">{{upravnik.email}}</div>
        <div class="col-2 text-podatki text-manjsi"><button class='btn btn-sm btn-outline-danger' @click.prevent="OdstraniUpravitelja(upravnik.id_pilota)"><i class="fas fa-trash"></i></button></div>
      </div>
    </div>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>